import { render, staticRenderFns } from "./NumberDataRep.vue?vue&type=template&id=03fd4ee9&"
import script from "./NumberDataRep.vue?vue&type=script&lang=js&"
export * from "./NumberDataRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports